<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import ZjxxbglrBrowse from "./ZjxxbglrBrowse";
import ZjxxbglrEdit from "./ZjxxbglrEdit";
import ZjxxbglrForm from "./ZjxxbglrForm";
export default {
    name: "Zjxxbglr",
    components: { ZjxxbglrBrowse, ZjxxbglrEdit, ZjxxbglrForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "ZjxxbglrEdit";
            } else if (this.editProps.showForm === true) {
                return "ZjxxbglrForm";
            } else {
                return "ZjxxbglrBrowse";
            }
        }
    }
};
</script>
